import styled, { css } from 'styled-components';
import {
  LinkStyle,
  Button,
  ButtonSecondary,
  StaleParagraphMedium,
  StaleSubTitleMedium,
  StaleTitleH1,
} from 'components';

export const Wrapper = styled.div(
  ({ theme }) => css`
    width: 100%;
    height: calc(var(--vh, 1vh) * 100);
    background: ${theme.color.white};
    display: flex;
    flex-direction: column;

    .get-code {
      display: inline;
      border-bottom: 1px solid ${theme.color.dark};
      padding-bottom: 1px;

      &:hover {
        border-color: ${theme.color.transparent};
      }
    }

    .resend {
      font-size: 14px;
      color: ${theme.color.greyDark};
    }

    ${StaleParagraphMedium} {
      &:not(:last-child) {
        margin-bottom: 10px;
      }
    }

    .field {
      margin-top: 16px;

      ${StaleParagraphMedium} {
        margin-bottom: 14px;
      }

      ${StaleParagraphMedium} {
        ${LinkStyle} {
          display: inline;
          border-bottom: 1px solid ${theme.color.dark};
          padding-bottom: 1px;
          line-height: 14px;

          &:hover {
            border-color: ${theme.color.transparent};
          }
        }
      }

      .resend {
        color: ${theme.color.greyDark};
        margin-top: 7px;
      }
    }

    .btns-group {
      margin-top: auto;
      padding: 16px;
      text-align: center;
      color: ${theme.color.greyDark};
      background: ${theme.color.white};
      box-shadow: ${theme.shadow};
    }

    .or {
      display: flex;
      justify-content: center;
      position: relative;
      margin: 24px 0;

      span {
        font-weight: 500;
        padding: 0 10px;
        background: ${theme.color.white};
        position: relative;
      }

      &:before {
        content: '';
        width: 100%;
        height: 1px;
        background: ${theme.color.greyLight_2};
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto 0;
      }
    }

    ${ButtonSecondary}.google {
      position: relative;
      font-weight: 500;
      margin-bottom: 40px;

      svg {
        position: absolute;
        left: 0;
      }
    }

    form {
      & > ${Button} {
        margin: 24px 0;
      }
    }

    hr {
      background: ${theme.color.greyLight_2};
      height: 1px;
      width: 100%;
      margin: 18px 0;
    }

    .company-info {
      width: 100%;
      display: block;
      border-radius: 6px;
      padding: 8px 14px;
      background: ${theme.color.greyLight_4};
      border: 1px solid ${theme.color.greyLight_2};
      transition: ${theme.transition};
      margin-bottom: 8px;

      ${StaleParagraphMedium}:last-child,
      ${StaleParagraphMedium} {
        margin: 0;
        color: ${theme.color.greyDark};
      }
    }

    .additional {
      .row {
        justify-content: flex-start;

        &:not(:first-child) {
          margin-top: 22px;
        }

        ${StaleSubTitleMedium} {
          margin-left: 12px;
        }
      }
    }

    .quiz {
      padding-bottom: 4px;

      ${StaleParagraphMedium} {
        margin: 8px 0 -2px;
      }
    }

    .reviewed {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      margin: auto;

      ${StaleTitleH1} {
        margin-bottom: 16px;
      }

      ${StaleParagraphMedium} {
        margin-bottom: 30px;
      }

      ${Button} {
        @media (min-width: ${theme.breakpoint.largeMin}px) {
          min-width: 400px;
        }
      }
    }
  `
);
